<template>
  <div>
    <!-- Image Fullscreen Preview -->
    <v-dialog v-model="ImageDialog" content-class="elevation-0" fullscreen>
      <div style="background-color: rgba(1, 1, 1, 0); height: 100%">
        <v-btn
          fab
          color="greyColorLigthTwo"
          style="position: absolute; top: 40px; right: 40px; z-index: 1000"
          @click="ImageDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- Image or Video -->
        <div
          v-if="isCrousel"
          style="
            width: 100%;
            height: 100% !important;
            background: rgba(1, 1, 1, 0.9);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <v-carousel height="100vh">
            <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
            <v-carousel-item
              v-for="(item, i) in itemData.Files"
              :key="i"
              v-if="item.FileExtension !== '.mp4' && item.FileExtension !== '.mov'"
              :src="item.LocalUrl"
              contain
            >
            </v-carousel-item>
          </v-carousel>
        </div>

        <div
          v-if="isFiles"
          style="
            width: 100%;
            height: 100% !important;
            background: rgba(1, 1, 1, 0.9);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px;
          "
        >
          <v-img
            style="cursor: pointer; height: 90vh; width: 100%"
            class="align-end pa-4"
            :aspect-ratio="16 / 9"
            :src="itemData.Files[0].LocalUrl"
            contain
            v-if="isPhoto(getFileExtension(itemData.Files))"
          >
          </v-img>
          <video
            style="
              object-fit: contain !important;
              background-color: black !important;
              object-fit: contain !important;
              background-color: black !important;
              width: 100%;
              height: auto;
              max-height: 90%;
            "
            controls
            controlsList="nodownload"
            muted
            v-else-if="
              isVideo(getFileExtension(itemData.Files)) && !isVimeoLink
            "
          >
            <source :src="computedMedia.LocalUrl" type="video/mp4" />
          </video>
          <iframe
            v-else-if="isVimeoLink"
            title="vimeo-player"
            :src="getVimeoiFrameLink"
            width="640"
            height="360"
            frameborder="0"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </v-dialog>

    <div id="inspire" v-if="isCrousel">
      <v-carousel light>
        <template v-slot:prev="{ on, attrs }">
          <v-btn color="white" icon v-bind="attrs" v-on="on"
            ><v-icon>mdi-chevron-left</v-icon></v-btn
          >
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn color="white" icon v-bind="attrs" v-on="on"
            ><v-icon>mdi-chevron-right</v-icon></v-btn
          >
        </template>
        <v-carousel-item v-for="(item, i) in itemData.Files" :key="i" contain>
          <video
            style="
              object-fit: contain !important;
              background-color: black !important;
              width: 100%;
              height: auto;
              max-height: 90%;
            "
            controls
            controlsList="nodownload"
            muted
            v-if="isVideo(item.FileExtension)"
          >
            <source :src="item.LocalUrl" type="video/mp4" />
          </video>
          <v-img
            style="cursor: pointer"
            @click="ImageDialog = true"
            height="100%"
            :src="item.LocalUrl"
            contain
            v-else-if="isPhoto(item.FileExtension)"
          >
          </v-img>
          <v-layout
            justify-center
            align-center
            column
            v-else-if="isDocument(item.FileExtension)"
          >
            <div class="defaultColor--text font-weight-bold">
              {{ $t('description.downloadButtonDescription') }}
            </div>
            <v-btn
              elevation="0"
              color="defaultColor px-15 mt-10"
              dark
              class="text-capitalize"
              @click="openDocument(item.LocalUrl, itemData.Id)"
            >
              {{ $t('buttons.download') }}
            </v-btn>
          </v-layout>
          <v-layout justify-center align-center column v-else>
            <div class="defaultColor--text font-weight-bold">
              {{ $t('description.unsuppertedFile') }}
            </div>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </div>

    <div v-if="isFiles" color="greyColorLigthThree">
      <v-img
        style="cursor: pointer"
        @click="ImageDialog = true"
        class="align-end"
        :src="itemData.Files[0].LocalUrl"
        contain
        v-if="isPhoto(getFileExtension(itemData.Files))"
      >
      </v-img>
      <video
        :key="itemData.Files[0].Id"
        style="
          object-fit: contain !important;
          background-color: black !important;
          width: 100%;
          height: auto;
          max-height: 90%;
        "
        @ended="onEndedFile(itemData.Files[0].Id)"
        controls
        controlsList="nodownload"
        muted
        v-else-if="isVideo(getFileExtension(itemData.Files)) && !isVimeoLink"
      >
        <source :src="computedMedia.LocalUrl" type="video/mp4" />
      </video>
      <iframe
        v-else-if="isVimeoLink"
        title="vimeo-player"
        :src="getVimeoiFrameLink"
        style="width: 100%"
        height="500"
        frameborder="0"
        allowfullscreen
      >
      </iframe>
      <v-layout
        justify-center
        align-center
        column
        v-else-if="isDocument(getFileExtension(itemData.Files))"
      >
        <div class="defaultColor--text font-weight-bold">
          {{ $t('description.downloadButtonDescription') }}
        </div>
        <v-btn
          elevation="0"
          color="defaultColor px-15 mt-10"
          dark
          class="text-capitalize"
          @click="openDocument(itemData.Files[0].LocalUrl, itemData.Id)"
        >
          {{ $t('buttons.download') }}
        </v-btn>
      </v-layout>
      <v-layout justify-center align-center column v-else>
        <div class="defaultColor--text font-weight-bold">
          {{ $t('description.unsuppertedFile') }}
        </div>
      </v-layout>
    </div>
  </div>
</template>

<script>
import PostService from '../../services/PostService';

export default {
  data() {
    return {
      ImageDialog: false,
      observer: null,
    };
  },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    academyPost: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  mounted() {
    this.videoEndedControl();
    this.initializeObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initializeObserver() {
      const options = {
        root: null,
        threshold: 0.5,
      };

      this.observer = new IntersectionObserver(
        this.handleIntersection,
        options
      );

      const videos = this.$el.querySelectorAll('video');
      videos.forEach((video) => this.observer.observe(video));
    },
    handleIntersection(entries) {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // video.currentTime = 0;
          video.play().catch((err) => console.error('Autoplay error:', err));
        } else {
          video.pause();
        }
      });
    },

    isVideo(FileExtension) {
      if (
        FileExtension === '.MP4' ||
        FileExtension === '.mp4' ||
        FileExtension === '.mov' ||
        FileExtension === '.MOV'
      ) {
        return true;
      } else {
        false;
      }
    },

    isPhoto(FileExtension) {
      if (!this.isVimeoLink) {
        if (
          FileExtension === '.jpg' ||
          FileExtension === '.jpeg' ||
          FileExtension === '.png' ||
          FileExtension === '.JPG' ||
          FileExtension === '.JPEG' ||
          FileExtension === '.PNG'
        ) {
          return true;
        } else {
          false;
        }
      } else {
        false;
      }
    },

    isDocument(FileExtension) {
      if (!this.isVimeoLink) {
        if (
          FileExtension === '.pdf' ||
          FileExtension === '.docx' ||
          FileExtension === '.doc' ||
          FileExtension === '.pptx' ||
          FileExtension === '.ppt'
        ) {
          return true;
        } else {
          false;
        }
      } else {
        false;
      }
    },

    openDocument(link, id) {
      this.onEndedFile(id);
      openLink(link);
    },

    videoEndedControl() {
      //TODO: iframe için vide izlendi işlemi yapılacak (iframe)
      //Ekip kararı ile force update servisinden gelen parametre ile hesaplanan saniye sonra izlendi kabul edildi.
      //iFrame özellikleri yakalanabildiğinde detaylı yapılacak (CORS hatası)
      let time = 10;
      time = this.$store.state.videoViewsRate * 60;
      setTimeout(() => {
        if (this.isVimeoLink) {
          this.onEndedFile(this.itemData.Id);
        }
      }, time * 1000);
    },

    onEndedFile(id) {
      PostService.setPostViews(id)
        .then((res) => {})
        .catch((err) => {
          //showError(err);
        })
        .then(() => {});
    },

    getVimeoLink(itemData) {
      var vimeoArr = itemData.Properties.filter(
        (x) => x.Key == 'videoLink' && x.Value != ''
      );
      //Properties içinde videolink varsa vimeo videosudur
      if (vimeoArr.length > 0) {
        return vimeoArr[0].Value;
      } else {
        return null;
      }
    },

    getFileExtension(files) {
      if (files.length > 0) {
        return files[0].FileExtension;
      } else {
        return '';
      }
    },
  },
  computed: {
    computedMedia() {
      if (!this.isVimeoLink) {
        return this.itemData.Files.find(
          (i) => i.FileExtension === '.mp4' || i.FileExtension === '.mov'
        );
      } else {
        return null;
      }
    },

    getFileType() {
      console.log('da : ', this.itemData.FileExtension);
      if (
        this.itemData.FileExtension === '.MP4' ||
        this.itemData.FileExtension === '.mp4' ||
        this.itemData.FileExtension === '.mov' ||
        this.itemData.FileExtension === '.MOV'
      ) {
        return 'video';
      } else if (
        this.itemData.FileExtension === '.pdf' ||
        this.itemData.FileExtension === '.docx' ||
        this.itemData.FileExtension === '.doc' ||
        this.itemData.FileExtension === '.pptx' ||
        this.itemData.FileExtension === '.ppt'
      ) {
        return 'file';
      } else if (
        this.itemData.FileExtension === '.jpg' ||
        this.itemData.FileExtension === '.jpeg' ||
        this.itemData.FileExtension === '.png' ||
        this.itemData.FileExtension === '.JPG' ||
        this.itemData.FileExtension === '.JPEG' ||
        this.itemData.FileExtension === '.PNG'
      ) {
        return 'image';
      } else {
        return null;
      }
    },

    isFiles() {
      if (this.itemData.Files.length == 1) {
        return true;
      } else {
        if (this.isVimeoLink) {
          return true;
        } else {
          return false;
        }
      }
    },

    isCrousel() {
      if (this.itemData.Files.length > 1) {
        return true;
      } else {
        return false;
      }
    },

    isVimeoLink() {
      //Sadece Akademi post ise vimeo link var
      let statu = false;
      if (this.academyPost) {
        if (this.itemData.Properties.length > 0) {
          var vimeoArr = this.itemData.Properties.filter(
            (x) => x.Key == 'videoLink' && x.Value
          );
          //Properties içinde videolink varsa vimeo videosudur
          if (vimeoArr.length > 0) {
            statu = true;
          } else {
            statu = false;
          }
        } else if (this.itemData.Files.length > 0) {
          statu = false;
        }
      } else {
        statu = false;
      }
      return statu;
    },

    getVimeoiFrameLink() {
      console.log('iframeeee');
      var vimeoLink = this.getVimeoLink(this.itemData);
      console.log('video Link :', vimeoLink);
      if (vimeoLink) {
        let vimeoId = vimeoLink.split('/').pop().toString();
        console.log(
          'vimeo link :',
          `https://player.vimeo.com/video/${vimeoId}`
        );
        return `https://player.vimeo.com/video/${vimeoId}`;
      } else {
        return '';
      }
    },
  },
};
</script>
<style>
.v-responsive__content{
  height: 100%;
}
</style>
